module.exports = __webpack_public_path__ + "17985ccce4311b0e833366aff0743ce9.png";